import { Checkbox } from "@/components/ui/checkbox";
import { useLang } from "@/lib/i18n";

export const ExtrasFields = ({ value, onChange, settings }) => {
  const { t, money } = useLang();
  const opts = [
    { k: "rush", title: t("builder.rush"), desc: t("builder.rush_d") },
    { k: "cut", title: t("builder.cut"), desc: t("builder.cut_d", { fee: money(settings.cut_fee) }) },
    { k: "file_check", title: t("builder.check"), desc: t("builder.check_d", { fee: money(settings.file_check_fee) }) },
  ];
  return (
    <div className="flex flex-col gap-2">
      {opts.map(({ k, title, desc }) => (
        <label key={k} className={`flex cursor-pointer items-start gap-3 rounded-md border p-3.5 transition-colors ${value[k] ? "border-gold/60 bg-gold/5" : "border-white/10 hover:border-white/25"}`}>
          <Checkbox checked={value[k]} onCheckedChange={(c) => onChange({ ...value, [k]: !!c })} className="mt-0.5" data-testid={`extra-${k}-checkbox`} />
          <span>
            <span className="block font-bold">{title}</span>
            <span className="block text-sm text-slate-400">{desc}</span>
          </span>
        </label>
      ))}
    </div>
  );
};
